import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const HeartFilledIcon = props => {
  return (
    <Svg
      width={18}
      height={15}
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M5.4.25C2.62.25.25 2.33.25 5.03c0 1.863.872 3.431 2.028 4.73 1.153 1.295 2.64 2.382 3.983 3.292l2.319 1.57a.75.75 0 00.84 0l2.319-1.57c1.344-.91 2.83-1.997 3.982-3.292 1.157-1.299 2.029-2.867 2.029-4.73 0-2.7-2.37-4.78-5.15-4.78-1.434 0-2.695.672-3.6 1.542C8.095.922 6.833.25 5.4.25z"
        fill="#C900E0"
      />
    </Svg>
  );
};

export default HeartFilledIcon;
